import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import {
  Chart,
  RadarController,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  ArcElement,
  Tooltip,
  Legend,
  type ChartOptions,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

Chart.register(RadarController, RadialLinearScale, PointElement, LineElement, Filler, ArcElement, Tooltip, Legend);

interface RadarChartProps {
  data?: number[];
  labels?: string[];
//   [key: string]: any;
}

const RadarChart: React.FC<RadarChartProps> = ({ data, labels }) => {
  // Use props for chart data and labels
  const chartTitle = 'Radar Chart'; // Optionally accept a title prop if needed
  const chartLabels = labels || [];
  const chartDataValues = data || [];

  const baseOptions: ChartOptions<'radar'> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        angleLines: { display: true, color: 'rgba(0,0,0,0.04)' },
        grid: { color: 'rgba(0,0,0,0.04)' },
        ticks: { display: true, stepSize: 10, color: '#9E9E9E' },
        suggestedMin: 0,
        suggestedMax: 100,
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
  };


  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: chartTitle,
        data: chartDataValues,
        backgroundColor: 'rgba(137,142,169,0.08)',
        borderColor: '#54566A',
        pointBackgroundColor: '#54566A',
        borderWidth: 1,
        fill: true,
      },
    ],
  };
  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">{chartTitle}</Typography>
        <Typography variant="body2" sx={{ bgcolor: '#FFF4F0', px: 1, py: 0.5, borderRadius: 2, color: '#E17E61' }}>
          Standard Rate : ≥ 75%
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center">
        <Box sx={{ width: { xs: '84%', md: '68%' }, height: { xs: 420, md: 580 } }}>
          <Radar data={chartData} options={baseOptions} />
        </Box>
      </Box>
    </Paper>
  );
};
export default RadarChart;